import { AssessmentSubmissionModel } from '../airtable/models/assessmentSubmission';

export const assessmentSubmissionsApi = {
  submit: async (formData) => {
    try {
      const response = await AssessmentSubmissionModel.create(formData);
      return response;
    } catch (error) {
      throw new Error(`Failed to submit assessment: ${error.message}`);
    }
  },

  getAll: async () => {
    try {
      const assessments = await AssessmentSubmissionModel.getAll();
      return assessments;
    } catch (error) {
      throw new Error(`Failed to fetch assessments: ${error.message}`);
    }
  },

  getById: async (id) => {
    try {
      const assessment = await AssessmentSubmissionModel.getById(id);
      return assessment;
    } catch (error) {
      throw new Error(`Failed to fetch assessment: ${error.message}`);
    }
  },
};

